import { ButtonBase } from "@mui/material";
import React from "react";

/**
 * One purchasable add-on as the plan/order screens carry it. Assembled on the client from the
 * billing catalogue, so only the fields this card renders are named.
 */
interface AddOn {
  itemId: string;
  name: string;
  description?: string;
  price: number;
  quantity?: number | string;
  pricing_scheme?: string;
  unit_name?: string;
  unit?: string;
  type?: string;
}

interface AddOnCardProps {
  addOn: AddOn;
  isSelected?: boolean;
  onSelect?: (itemId: string) => void;
  disabled?: boolean;
  currencySymbol?: string;
  handleUnitIncrease?: (e: React.ChangeEvent<HTMLInputElement>, addOn: AddOn) => void;
}

function AddOnCard({
  addOn,
  isSelected,
  onSelect,
  disabled = true,
  currencySymbol,
  handleUnitIncrease = () => {},
}: AddOnCardProps) {
  return (
    <div
      className={`rounded-2xl cursor-pointer w-[14.0625rem] h-[9.375rem] flex border-4 ${
        isSelected ? "border-[#6BBBE3]" : "border-transparent"
      }`}
    >
      <ButtonBase
        component="div"
        className={"rounded-2xl"}
        // `defaultProps` below supplies the no-op default TypeScript cannot see. Erased assertion.
        onClick={() => onSelect!(addOn.itemId)}
        style={{
          boxSizing: "border-box",
          boxShadow: "0 0 0.625rem rgba(0, 0, 0, 0.1), 0.375rem 0.375rem 0.75rem rgba(0, 0, 0, 0.1)",
        }}
        disabled={disabled}
      >
        <div className="gap-2.5 flex items-start flex-col m-4 overflow-auto ">
          <div className="text-lg font-semibold">{addOn.name}</div>
          <div className="flex gap-2 h-6">
            {addOn.pricing_scheme == "unit" && (
              <>
                <input
                  style={{
                    outline: "none",
                  }}
                  className="border border-text_light text-text_light rounded-sm px-2 py-1 w-12"
                  min="0"
                  type="number"
                  value={addOn.quantity}
                  onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
                  onChange={(e) => handleUnitIncrease(e, addOn)}
                  disabled={disabled}
                />
                <div className="flex items-center">{"×"}</div>
              </>
            )}

            <div className="flex items-center text-xs font-semibold">
              {currencySymbol} {addOn.price.toLocaleString("en-IN")}
              {addOn.pricing_scheme === "unit" && ` / ${addOn.unit_name || addOn.unit}`}
              {addOn.type === "recurring" && " / year"}
            </div>
          </div>
          <div className="text-xs flex text-gray-500 text-start">{addOn.description}</div>
        </div>
      </ButtonBase>
    </div>
  );
}

AddOnCard.defaultProps = {
  isSelected: false,
  onSelect: () => {},
  disabled: true,
  currencySymbol: "₹",
  handleUnitIncrease: () => {},
};

export default AddOnCard;
